import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
import { selectAuth } from '../store/authSlice';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Проверка сессии занимает доли секунды. Раньше здесь был тёмный
 * полноэкранный лоадер, после которого сразу рисовалась светлая страница с
 * сайдбаром — экран мигал. Заглушка повторяет каркас кабинета: светлый фон и
 * колонку сайдбара нужной ширины (с учётом свёрнутого состояния).
 */
const AuthCheckPlaceholder: React.FC = () => {
  let collapsed = false;
  try {
    collapsed = localStorage.getItem('sidebarCollapsed') === 'true';
  } catch {
    // нет доступа к storage — рисуем развёрнутый сайдбар
  }
  return (
    <div
      className={`auth-check-placeholder ${collapsed ? 'is-collapsed' : ''}`}
      role="status"
      aria-label="Проверка авторизации"
    />
  );
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading } = useAppSelector(selectAuth);

  if (loading) {
    return <AuthCheckPlaceholder />;
  }

  if (isAuthenticated) {
    return <>{children}</>;
  } else {
    return <Navigate to="/login" replace />;
  }
};

export default ProtectedRoute;
